import { FeedbackInbox } from '@/components/feedback-inbox';

/** Feedback people sent to the Nirvik Ready team. */
export function AdminFeedbackPage() {
  return <FeedbackInbox scope={{ kind: 'platform' }} canManage />;
}
